import { Modal, Spinner } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"


import './Modal.scss'


export default function ModalLoadingLogout({ msg, title, show, setShow, show_msg }) {

    const handlerSimpleClose = () => setShow(false)

    return (
        <>
            <Modal
                show={show}
                onHide={handlerSimpleClose}
                backdrop='static'
                keyboard={false}
                centered
                size='md'
            >
                <Modal.Body style={{
                    fontSize: '1.8rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div className="d-flex flex-column justify-content-center text-center">
                    {msg ? <h1 className="mb-2 text-center" style={{fontSize:'2rem'}}>{ msg }</h1>: "" }      
                        <div>
                            <Spinner variant="info" size="md" animation="grow" style={{marginRight:'10px'}}/> 
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
